import { render, staticRenderFns } from "./submitSetting.vue?vue&type=template&id=7f431965&scoped=true"
import script from "./submitSetting.vue?vue&type=script&lang=ts"
export * from "./submitSetting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f431965",
  null
  
)

export default component.exports